"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  OfficeFileModuleEdit: ['office-file-module-edit', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.498 13.498 L8.998 13.498 L8.998 17.998 L4.498 17.998 Z', 'M7.498 5.998 L13.498 5.998 L13.498 10.498 L7.498 10.498 Z', 'M13.5,18A1.5,1.5,0,0,1,12,16.5V15a1.5,1.5,0,0,1,1.5-1.5H15A1.5,1.5,0,0,1,16.5,15', 'M18.277,22.742l-2.529.506.506-2.529,4.552-4.552a1.43,1.43,0,0,1,2.023,0h0a1.43,1.43,0,0,1,0,2.023Z', 'M12,23.248H3A2.25,2.25,0,0,1,.748,21V3A2.25,2.25,0,0,1,3,.748H17.377a1.5,1.5,0,0,1,1.061.439l4.371,4.372a1.5,1.5,0,0,1,.439,1.06v6.129', 'M17.248.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFilePdf1: ['office-file-pdf-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.246,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.875a1.5,1.5,0,0,1,1.061.44l5.871,5.871a1.5,1.5,0,0,1,.439,1.061v4.628', 'M20.246,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M8.246 23.248L8.246 15.748', 'M8.246,15.748H9a2.25,2.25,0,0,1,0,4.5h-.75', 'M14.246,23.248a3,3,0,0,0,3-3v-1.5a3,3,0,0,0-3-3Z', 'M20.246,23.248v-6a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M20.246 20.248L22.496 20.248']],
  FileRar1: ['file-rar-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.496 19.498L4.496 11.998', 'M4.5,12H5.621a1.875,1.875,0,0,1,0,3.75H4.5', 'M7.496 19.498L5.246 15.748', 'M16.496 19.498L16.496 11.998', 'M16.5,12h1.125a1.875,1.875,0,0,1,0,3.75H16.5', 'M19.496 19.498L17.246 15.748', 'M10.5,19.5v-6a1.5,1.5,0,0,1,3,0v6', 'M10.496 16.498L13.496 16.498', 'M22.807,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.746,21V3A2.25,2.25,0,0,1,3,.748H17.375a1.5,1.5,0,0,1,1.061.439Z', 'M17.246.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileAdobe: ['office-file-adobe', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.494,21.748a1.5,1.5,0,0,1-1.5,1.5h-18a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.047.426l3,2.883a1.5,1.5,0,0,1,.453,1.074Z', 'M9.49,7.085A3.954,3.954,0,0,0,8.981,5.62a1.569,1.569,0,0,0-1.289-.758A1.5,1.5,0,0,0,6.367,6.146,2.758,2.758,0,0,0,6.854,8.04a42.5,42.5,0,0,0,3.936,3.971,17.631,17.631,0,0,0,5.236,2.929,3.775,3.775,0,0,0,1.664.354,1.379,1.379,0,0,0,1.265-.98,1.309,1.309,0,0,0-.484-1.206,2.743,2.743,0,0,0-1.237-.536,10.778,10.778,0,0,0-5.321.565c-1.622.5-6.362,2.066-6.144,6.051.006.1-.007.762.847.666a2.583,2.583,0,0,0,1.708-1.186c1.093-1.543,1.207-3.51,1.35-5.331A24.062,24.062,0,0,0,9.49,7.085Z']],
  FileZip: ['file-zip', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.249,15.748h1.892a.75.75,0,0,1,.7,1.029L11.66,22.22a.749.749,0,0,0,.7,1.028h1.892', 'M17.249 23.248L17.249 15.748', 'M20.249 23.248L20.249 15.748', 'M20.249,15.748H21a2.25,2.25,0,0,1,0,4.5h-.75', 'M8.249,23.248h-6a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.877a1.5,1.5,0,0,1,1.061.439l5.871,5.872a1.5,1.5,0,0,1,.44,1.06v4.629', 'M20.249,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6']],
  OfficeFileDoc1: ['office-file-doc-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.247,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.876a1.5,1.5,0,0,1,1.061.439l5.871,5.872a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.247,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M8.247,23.248a3,3,0,0,0,3-3v-1.5a3,3,0,0,0-3-3Z', 'M15.747,15.748a1.5,1.5,0,0,0-1.5,1.5v4.5a1.5,1.5,0,1,0,3,0v-4.5A1.5,1.5,0,0,0,15.747,15.748Z', 'M23.247,15.748a3,3,0,0,0-3,3v1.5a3,3,0,0,0,3,3']],
  OfficeFileAdobeAlternate: ['office-file-adobe-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.515,6.723a3.954,3.954,0,0,0-.509-1.465A1.569,1.569,0,0,0,6.717,4.5,1.5,1.5,0,0,0,5.392,5.784a2.756,2.756,0,0,0,.487,1.893,42.285,42.285,0,0,0,3.936,3.972,17.631,17.631,0,0,0,5.236,2.929,3.789,3.789,0,0,0,1.664.354,1.379,1.379,0,0,0,1.265-.981,1.311,1.311,0,0,0-.484-1.206,2.752,2.752,0,0,0-1.237-.535,10.789,10.789,0,0,0-5.321.564c-1.622.5-6.362,2.067-6.144,6.052a.858.858,0,0,0,.089.382.758.758,0,0,0,.758.284,2.583,2.583,0,0,0,1.708-1.186c1.093-1.543,1.207-3.51,1.35-5.331A24.062,24.062,0,0,0,8.515,6.723Z', 'M22.81,5.56a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.249H3A2.25,2.25,0,0,1,.749,21V3A2.25,2.25,0,0,1,3,.749H17.378a1.5,1.5,0,0,1,1.061.439Z', 'M17.249.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileHierarchyAlternate: ['office-file-hierarchy-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.249 14.999 L9.749 14.999 L9.749 19.499 L5.249 19.499 Z', 'M8.249 4.499 L14.249 4.499 L14.249 8.999 L8.249 8.999 Z', 'M12.749 14.999 L17.249 14.999 L17.249 19.499 L12.749 19.499 Z', 'M5.999 11.999L16.499 11.999', 'M11.249 11.999L11.249 13.499', 'M22.81,5.559a1.5,1.5,0,0,1,.439,1.061V21A2.25,2.25,0,0,1,21,23.249H3A2.251,2.251,0,0,1,.749,21V3A2.25,2.25,0,0,1,3,.749H17.378a1.5,1.5,0,0,1,1.061.439Z', 'M17.249.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileKey1: ['office-file-key-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.249,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.878a1.5,1.5,0,0,1,1.06.439L19.81,7.059a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.249,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M8.249 23.248L8.249 15.748', 'M11.249 23.248L8.249 19.498 11.249 15.748', 'M17.249,23.248h-1.5a1.5,1.5,0,0,1-1.5-1.5v-4.5a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M14.249 20.248L17.249 20.248', 'M20.249,15.748V18a1.5,1.5,0,0,0,3,0v-2.25', 'M21.749 19.498L21.749 23.248']],
  OfficeFilePdf: ['office-file-pdf', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.499 19.498L4.499 11.998', 'M4.5,12h.75a2.25,2.25,0,0,1,0,4.5H4.5', 'M10.5,19.5a3,3,0,0,0,3-3V15a3,3,0,0,0-3-3Z', 'M16.5,19.5v-6A1.5,1.5,0,0,1,18,12h1.5', 'M16.499 16.498L18.749 16.498', 'M22.809,5.559a1.5,1.5,0,0,1,.44,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.749,21V3A2.25,2.25,0,0,1,3,.748H17.377a1.5,1.5,0,0,1,1.061.439Z', 'M17.249.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileModuleEditAlternate: ['office-file-module-edit-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.251 12.749 L9.751 12.749 L9.751 17.249 L5.251 17.249 Z', 'M8.251 5.249 L14.251 5.249 L14.251 9.749 L8.251 9.749 Z', 'M14.251,17.249a1.5,1.5,0,0,1-1.5-1.5v-1.5a1.5,1.5,0,0,1,1.5-1.5h1.5a1.5,1.5,0,0,1,1.5,1.5', 'M18.28,22.743l-2.529.506.506-2.529,4.552-4.552a1.43,1.43,0,0,1,2.023,0h0a1.43,1.43,0,0,1,0,2.023Z', 'M12.751,23.249H2.251a1.5,1.5,0,0,1-1.5-1.5V2.249a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.048.426l3,2.883a1.5,1.5,0,0,1,.452,1.074v7.617']],
  OfficeFilePps: ['office-file-pps', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.502 19.498L4.502 11.998', 'M4.5,12h.75a2.25,2.25,0,0,1,0,4.5H4.5', 'M10.502 19.498L10.502 11.998', 'M10.5,12h.75a2.25,2.25,0,0,1,0,4.5H10.5', 'M19.5,12H18a1.5,1.5,0,0,0-1.5,1.5c0,2.25,3,2.25,3,4.5A1.5,1.5,0,0,1,18,19.5H16.5', 'M22.813,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.752,21V3A2.25,2.25,0,0,1,3,.748H17.381a1.5,1.5,0,0,1,1.061.439Z', 'M17.252.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFilePpt: ['office-file-ppt', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.503 19.498L4.503 11.998', 'M4.5,12h.75a2.25,2.25,0,0,1,0,4.5H4.5', 'M10.503 19.498L10.503 11.998', 'M10.5,12h.75a2.25,2.25,0,0,1,0,4.5H10.5', 'M18.003 19.498L18.003 11.998', 'M16.503 11.998L19.503 11.998', 'M22.814,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.753,21V3A2.25,2.25,0,0,1,3,.748H17.382a1.5,1.5,0,0,1,1.06.439Z', 'M17.253.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileRtf1: ['office-file-rtf-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.249,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.878a1.5,1.5,0,0,1,1.061.439L19.81,7.059a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.249,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M15.749 23.248L15.749 15.748', 'M14.249 15.748L17.249 15.748', 'M20.249,23.248v-6a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M20.249 20.248L22.499 20.248', 'M8.249 23.248L8.249 15.748', 'M8.249,15.748H9.374a1.875,1.875,0,0,1,0,3.75H8.249', 'M11.249 23.248L8.999 19.498']],
  OfficeFileSheetAlternate: ['office-file-sheet-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.999 10.499L8.999 19.499', 'M4.499 14.999L19.499 14.999', 'M22.81,5.56a1.5,1.5,0,0,1,.439,1.061V21A2.25,2.25,0,0,1,21,23.249H3A2.25,2.25,0,0,1,.749,21V3A2.251,2.251,0,0,1,3,.749H17.378a1.5,1.5,0,0,1,1.061.44Z', 'M17.249.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5', 'M19.5,18.749a.75.75,0,0,1-.75.75H5.249a.75.75,0,0,1-.75-.75V10.5h14.25a.75.75,0,0,1,.75.75Z', 'M13.5,10.5h-9V8.249a.75.75,0,0,1,.75-.75H13.5']],
  OfficeFilePpt1: ['office-file-ppt-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.249,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.878a1.5,1.5,0,0,1,1.061.439L19.81,7.059a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.249,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M8.249 23.248L8.249 15.748', 'M8.249,15.748H9a2.25,2.25,0,0,1,0,4.5h-.75', 'M14.249 23.248L14.249 15.748', 'M14.249,15.748H15a2.25,2.25,0,0,1,0,4.5h-.75', 'M21.749 23.248L21.749 15.748', 'M20.249 15.748L23.249 15.748']],
  OfficeFilePresentation: ['office-file-presentation', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.81,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.749,21V3A2.25,2.25,0,0,1,3,.748H17.378a1.5,1.5,0,0,1,1.061.439Z', 'M17.249.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5', 'M17.249,9.748v4.5a.75.75,0,0,1-.75.75h-9a.75.75,0,0,1-.75-.75v-6A.75.75,0,0,1,7.5,7.5H15', 'M11.999 14.998L11.999 19.498', 'M8.999 19.498L11.999 16.498', 'M14.999 19.498L11.999 16.498']],
  OfficeFilePresentation1: ['office-file-presentation-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,21.748a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V2.248A1.5,1.5,0,0,1,3,.748H18a1.5,1.5,0,0,1,1.048.426l3,2.883A1.5,1.5,0,0,1,22.5,5.131Z', 'M6.752 6.748 L17.252 6.748 L17.252 14.248 L6.752 14.248 Z', 'M12.002 14.248L12.002 18.748', 'M9.002 18.748L12.002 15.748', 'M15.002 18.748L12.002 15.748']],
  OfficeFileTextAlternate: ['office-file-text-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.499 16.499L7.499 10.499', 'M4.499 11.999L4.499 10.499 10.499 10.499 10.499 11.999', 'M14.249 14.999L19.499 14.999', 'M14.249 10.499L19.499 10.499', 'M4.499 19.499L19.499 19.499', 'M5.999 16.499L8.999 16.499', 'M22.809,5.56a1.5,1.5,0,0,1,.44,1.061V21A2.25,2.25,0,0,1,21,23.249H3A2.25,2.25,0,0,1,.749,21V3A2.25,2.25,0,0,1,3,.749H17.377a1.5,1.5,0,0,1,1.061.44Z', 'M17.249.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileTextGraph: ['office-file-text-graph', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.748,21.748a1.5,1.5,0,0,1-1.5,1.5h-18a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.047.426l3,2.883a1.5,1.5,0,0,1,.453,1.074Z', 'M16.498 9.748L17.248 9.748', 'M14.998 5.248L17.248 5.248', 'M13.498 14.248L17.248 14.248', 'M5.248 18.748L17.248 18.748', 'M3.748 8.998 A4.500 4.500 0 1 0 12.748 8.998 A4.500 4.500 0 1 0 3.748 8.998 Z', 'M4.544 11.467L8.248 8.998 8.248 4.498']],
  OfficeFileTxt1: ['office-file-txt-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.247,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.876a1.5,1.5,0,0,1,1.06.439l5.872,5.872a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.247,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M21.747 23.248L21.747 15.748', 'M20.247 15.748L23.247 15.748', 'M9.747 23.248L9.747 15.748', 'M8.247 15.748L11.247 15.748', 'M14.247 15.748L17.247 23.248', 'M17.247 15.748L14.247 23.248']],
  OfficeFileXls1: ['office-file-xls-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.249,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.878a1.5,1.5,0,0,1,1.06.439L19.81,7.059a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.249,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M8.249 15.748L11.249 23.248', 'M11.249 15.748L8.249 23.248', 'M14.249,15.748v6a1.5,1.5,0,0,0,1.5,1.5h1.5', 'M23.249,15.748h-1.5a1.5,1.5,0,0,0-1.5,1.5c0,2.25,3,2.25,3,4.5a1.5,1.5,0,0,1-1.5,1.5h-1.5']],
  OfficeFileSheet: ['office-file-sheet', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,21.748a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V2.248A1.5,1.5,0,0,1,3,.748H18a1.5,1.5,0,0,1,1.047.426l3,2.883A1.5,1.5,0,0,1,22.5,5.131Z', 'M9.749 10.498L9.749 19.498', 'M5.249 14.998L18.749 14.998', 'M5.249 7.498 L18.749 7.498 L18.749 19.498 L5.249 19.498 Z', 'M5.249 10.498L18.749 10.498']],
  OfficeFileGlueAlternate: ['office-file-glue-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25 14.249L4.5 14.249', 'M9 18.749L4.5 18.749', 'M16.5 9.749L4.5 9.749', 'M17.622,22.189a.749.749,0,0,1-1.06,0L13.38,19.007a.75.75,0,0,1,0-1.061l2.063-2.063a.693.693,0,0,1,.127-.1l5.257-3.345a.749.749,0,0,1,.933.1l1.27,1.27a.749.749,0,0,1,.1.933L19.788,20a.791.791,0,0,1-.1.128Z', 'M16.031 21.659L14.44 23.249 10.5 23.249 13.91 19.537', 'M7.5,23.249H3A2.25,2.25,0,0,1,.75,21V3A2.25,2.25,0,0,1,3,.749H17.379a1.5,1.5,0,0,1,1.06.44L22.811,5.56a1.5,1.5,0,0,1,.439,1.061V9.749', 'M17.25.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileStamp: ['office-file-stamp', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.748 11.998L4.498 11.998', 'M10.498 16.498L4.498 16.498', 'M17.998 7.498L4.498 7.498', 'M22.209,19.261a.751.751,0,0,0-.711-.513h-2.25V16.5a2.25,2.25,0,1,0-3,0v2.25H14a.751.751,0,0,0-.712.513l-1,3a.749.749,0,0,0,.712.987h9.5a.749.749,0,0,0,.711-.987Z', 'M9,23.248H2.248a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.047.427l3,2.882a1.5,1.5,0,0,1,.453,1.074V10.5']],
  OfficeFileText: ['office-file-text', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,21.748a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V2.248A1.5,1.5,0,0,1,3,.748H18a1.5,1.5,0,0,1,1.047.427l3,2.882A1.5,1.5,0,0,1,22.5,5.131Z', 'M9 11.248L9 5.248', 'M6 6.748L6 5.248 12 5.248 12 6.748', 'M15.75 9.748L18 9.748', 'M15.75 5.248L18 5.248', 'M6 14.248L18 14.248', 'M6 18.748L18 18.748', 'M7.5 11.248L10.5 11.248']],
  OfficeFileTextGraphAlternate: ['office-file-text-graph-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.249 14.999L19.499 14.999', 'M15.749 10.499L19.499 10.499', 'M14.249 19.499L19.499 19.499', 'M4.499 14.249 A4.500 4.500 0 1 0 13.499 14.249 A4.500 4.500 0 1 0 4.499 14.249 Z', 'M5.294 16.718L8.999 14.249 8.999 9.749', 'M22.809,5.559a1.5,1.5,0,0,1,.44,1.061V21A2.251,2.251,0,0,1,21,23.249H3A2.25,2.25,0,0,1,.749,21V3A2.25,2.25,0,0,1,3,.749H17.377a1.5,1.5,0,0,1,1.061.439Z', 'M17.249.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileGraph: ['office-file-graph', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.454,21.748a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V2.248A1.5,1.5,0,0,1,3,.748H18a1.5,1.5,0,0,1,1.047.426L22,4.057a1.5,1.5,0,0,1,.452,1.074Z', 'M5.204 9.748 A5.250 5.250 0 1 0 15.704 9.748 A5.250 5.250 0 1 0 5.204 9.748 Z', 'M5.205 9.748L10.435 9.748 11.581 14.877', 'M10.435 9.748L14.167 6.036', 'M18.704 16.498L15.704 16.498', 'M18.704 19.498L11.954 19.498']],
  OfficeFileKey: ['office-file-key', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.502 19.498L4.502 11.998', 'M7.502 19.498L4.502 15.748 7.502 11.998', 'M13.5,19.5H12A1.5,1.5,0,0,1,10.5,18V13.5A1.5,1.5,0,0,1,12,12h1.5', 'M10.502 16.498L13.502 16.498', 'M16.5,12v2.25a1.5,1.5,0,1,0,3,0V12', 'M18.002 15.748L18.002 19.498', 'M22.813,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.752,21V3A2.25,2.25,0,0,1,3,.748H17.381a1.5,1.5,0,0,1,1.061.439Z', 'M17.252.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileHierarchy: ['office-file-hierarchy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.999 15.748 L10.499 15.748 L10.499 20.248 L5.999 20.248 Z', 'M8.999 5.248 L14.999 5.248 L14.999 9.748 L8.999 9.748 Z', 'M13.499 15.748 L17.999 15.748 L17.999 20.248 L13.499 20.248 Z', 'M6.749 12.748L17.249 12.748', 'M11.999 12.748L11.999 14.248', 'M22.5,21.748a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V2.248A1.5,1.5,0,0,1,3,.748H18a1.5,1.5,0,0,1,1.047.426l3,2.883A1.5,1.5,0,0,1,22.5,5.131Z']],
  OfficeFilePps1: ['office-file-pps-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.061.439l5.871,5.872a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.25,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6', 'M8.25 23.248L8.25 15.748', 'M8.25,15.748H9a2.25,2.25,0,0,1,0,4.5H8.25', 'M14.25 23.248L14.25 15.748', 'M14.25,15.748H15a2.25,2.25,0,0,1,0,4.5h-.75', 'M23.25,15.748h-1.5a1.5,1.5,0,0,0-1.5,1.5c0,2.25,3,2.25,3,4.5a1.5,1.5,0,0,1-1.5,1.5h-1.5']],
  OfficeFileStampAlternate: ['office-file-stamp-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.211,19.262a.751.751,0,0,0-.712-.513h-2.25V16.5a2.25,2.25,0,1,0-3,0v2.25H14a.751.751,0,0,0-.711.513l-1,3a.749.749,0,0,0,.711.987h9.5a.749.749,0,0,0,.712-.987Z', 'M11.249 14.249L4.499 14.249', 'M8.999 18.749L4.499 18.749', 'M16.499 9.749L4.499 9.749', 'M8.249,23.249H3A2.25,2.25,0,0,1,.749,21V3A2.251,2.251,0,0,1,3,.749H17.378a1.5,1.5,0,0,1,1.061.44L22.81,5.56a1.5,1.5,0,0,1,.439,1.061v6.128', 'M17.249.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileXls: ['office-file-xls', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.503 11.998L7.503 19.498', 'M7.503 11.998L4.503 19.498', 'M10.5,12v6A1.5,1.5,0,0,0,12,19.5h1.5', 'M19.5,12H18a1.5,1.5,0,0,0-1.5,1.5c0,2.25,3,2.25,3,4.5A1.5,1.5,0,0,1,18,19.5H16.5', 'M22.814,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.753,21V3A2.25,2.25,0,0,1,3,.748H17.382a1.5,1.5,0,0,1,1.06.439Z', 'M17.253.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  FileRar: ['file-rar', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.248 23.248L8.248 15.748', 'M8.248,15.748H9.373a1.875,1.875,0,0,1,0,3.75H8.248', 'M11.248 23.248L8.998 19.498', 'M20.248 23.248L20.248 15.748', 'M20.248,15.748h1.125a1.875,1.875,0,0,1,0,3.75H20.248', 'M23.248 23.248L20.998 19.498', 'M14.248,23.248v-6a1.5,1.5,0,0,1,3,0v6', 'M14.248 20.248L17.248 20.248', 'M5.248,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.877a1.5,1.5,0,0,1,1.06.439l5.872,5.872a1.5,1.5,0,0,1,.439,1.06v4.629', 'M20.248,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6']],
  OfficeFileDoc: ['office-file-doc', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,19.5a3,3,0,0,0,3-3V15a3,3,0,0,0-3-3Z', 'M12,12a1.5,1.5,0,0,0-1.5,1.5V18a1.5,1.5,0,0,0,3,0V13.5A1.5,1.5,0,0,0,12,12Z', 'M19.5,12a3,3,0,0,0-3,3v1.5a3,3,0,0,0,3,3', 'M22.81,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.749,21V3A2.25,2.25,0,0,1,3,.748H17.378a1.5,1.5,0,0,1,1.061.439Z', 'M17.249.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileRtf: ['office-file-rtf', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5 19.498L13.5 11.998', 'M12 11.998L15 11.998', 'M18,19.5v-6A1.5,1.5,0,0,1,19.5,12H21', 'M18 16.498L20.25 16.498', 'M6 19.498L6 11.998', 'M6,12H7.125a1.875,1.875,0,0,1,0,3.75H6', 'M9 19.498L6.75 15.748', 'M22.811,5.559A1.5,1.5,0,0,1,23.25,6.62V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.75,21V3A2.251,2.251,0,0,1,3,.748H17.379a1.5,1.5,0,0,1,1.061.44Z', 'M17.25.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileGraphAlternate: ['office-file-graph-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.812,5.559a1.5,1.5,0,0,1,.439,1.061V21A2.25,2.25,0,0,1,21,23.249H3A2.251,2.251,0,0,1,.751,21V3A2.25,2.25,0,0,1,3,.749H17.38a1.5,1.5,0,0,1,1.061.439Z', 'M17.251.749v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5', 'M4.501 9.749 A5.250 5.250 0 1 0 15.001 9.749 A5.250 5.250 0 1 0 4.501 9.749 Z', 'M4.502 9.749L9.732 9.749 10.878 14.878', 'M9.732 9.749L13.464 6.037', 'M19.501 16.499L15.001 16.499', 'M19.501 19.499L11.251 19.499']],
  OfficeFileTxt: ['office-file-txt', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.998 19.498L17.998 11.998', 'M16.498 11.998L19.498 11.998', 'M5.998 19.498L5.998 11.998', 'M4.498 11.998L7.498 11.998', 'M10.498 11.998L13.498 19.498', 'M13.498 11.998L10.498 19.498', 'M22.809,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.748,21V3A2.25,2.25,0,0,1,3,.748H17.377a1.5,1.5,0,0,1,1.061.439Z', 'M17.248.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  FileZip1: ['file-zip-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,12H7.889a.75.75,0,0,1,.7,1.029L6.408,18.47A.749.749,0,0,0,7.1,19.5H9', 'M11.996 19.498L11.996 11.998', 'M14.996 19.498L14.996 11.998', 'M15,12h.75a2.25,2.25,0,0,1,0,4.5H15', 'M22.807,5.559a1.5,1.5,0,0,1,.439,1.06V21A2.25,2.25,0,0,1,21,23.248H3A2.25,2.25,0,0,1,.746,21V3A2.25,2.25,0,0,1,3,.748H17.375a1.5,1.5,0,0,1,1.061.439Z', 'M17.246.748v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5']],
  OfficeFileGlue: ['office-file-glue', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.749 11.998L4.499 11.998', 'M8.999 16.498L4.499 16.498', 'M17.999 7.498L4.499 7.498', 'M7.5,23.248H2.249a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.047.427l3,2.882a1.5,1.5,0,0,1,.453,1.074V9', 'M17.621,22.188a.75.75,0,0,1-1.061,0l-3.182-3.182a.75.75,0,0,1,0-1.061l2.063-2.063a.735.735,0,0,1,.128-.1l5.257-3.346a.751.751,0,0,1,.933.1l1.27,1.27a.749.749,0,0,1,.1.933L19.786,20a.735.735,0,0,1-.1.128Z', 'M16.03 21.657L14.439 23.248 10.499 23.248 13.909 19.536']]
};
exports["default"] = _default;